export default __webpack_public_path__ + "static/media/faceGreen.30b4ee76.svg";